import { LE_BUSINESS_TRAVELLER } from '~/consts/businessTraveller';

// Returns business_id only for LEBT orders, undefined otherwise
export function getLebtBusinessId(order?: { brand?: string; business_id?: string }): string | undefined {
  if (order?.brand === LE_BUSINESS_TRAVELLER && order.business_id) {
    return order.business_id;
  }
  return undefined;
}
